import Contestant from './contestant';
import { Condition } from './contestant';
import { item } from './item';
export default class Group {
    //when group is created, combine all individuals' items into one array then delete all items from individuals
    constructor(thePpl, theItems, theString) {
        this.creationString = "";
        let newarr = [];
        for (let i = 0; i < thePpl.length; i++) {
            let temp = thePpl[i];
            if (temp instanceof Group) {
                for (let j = 0; j < temp.getConts().length; j++) {
                    newarr.push(temp.getConts()[j]);
                }
            }
            else {
                newarr.push(temp);
            }
        }
        this.ppl = newarr;
        this.items = theItems;
        this.creationString = theString;
        this.isInGroup = false;
    }
    isGroup() {
        return true;
    }
    getName() {
        if (this.ppl.length <= 1) {
            return this.ppl[0].getName();
        }
        else if (this.ppl.length == 2) {
            return this.ppl[0].getName() + " and " + this.ppl[1].getName();
        }
        else {
            let build = "";
            for (let i = 0; i < this.ppl.length - 1; i++) {
                build += this.ppl[i].getName() + ", ";
            }
            build += "and " + this.ppl[this.ppl.length - 1].getName();
            return build;
        }
    }
    getConts() {
        return this.ppl;
    }
    getItems() {
        return this.items;
    }
    addItem(x) {
        this.items.push(x);
    }
    loseItem(x) {
        if (this.items.length > 0) {
            this.items.splice(x, 1);
            return true;
        }
        return false;
    }
    newMember(x) {
        this.ppl.push(x);
    }
    loseMember(y) {
        this.ppl[y].setIsInGroup(false);
        this.ppl.splice(y, 1);
    }
    setString(x) {
        this.creationString = x;
    }
    getString() {
        return this.creationString;
    }
    setIsInGroup(x) {
        this.isInGroup = x;
    }
    getIsInGroup() {
        return this.isInGroup;
    }
    purge() {
        //remove dead members of group
        for (let j = 0; j < this.ppl.length; j++) {
            if (this.ppl[j].getCond() == 0) {
                this.ppl.splice(j, 1);
                j--;
            }
        }
    }
    //polymorphic, selects verb based on pronoun (used for subject-verb agreement)
    verbSwitchPro(x, y) {
        return y;
    }
    //polymorphic, selects verb based on if called on (used for subject-verb agreement)
    verbSwitchName(x, y) {
        return y;
    }
    getPronoun() {
        return "they";
    }
    getObjpronoun() {
        return "them";
    }
    getPospronoun() {
        return "their";
    }
    //returns array of images of all members of group
    getImage() {
        let temparr = [];
        for (let i = 0; i < this.ppl.length; i++) {
            temparr.push(this.ppl[i].getImage()[0]);
        }
        return temparr;
    }
    //none of these should be used
    //TODO: improve type checking so these aren't needed
    getCond() { console.log("ERROR: getCond called on group"); return Condition.HEALTHY; }
    loseWeapon() { console.log("ERROR: loseWeapon called on group"); }
}
